import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import SeoHead from "../components/Seo/SeoHead";
import ErrorBoundary from "../components/ui/ErrorBoundary";

export default function Layout() {
    const location = useLocation();

    return (
        <div className="flex min-h-screen flex-col bg-canvas font-sans text-body">
            <SeoHead />
            <Header />
            <main className="flex-grow bg-canvas pt-[72px]">
                <ErrorBoundary key={location.pathname}>
                    <Outlet />
                </ErrorBoundary>
            </main>
            <Footer />
        </div>
    );
}
